import axios from "axios";

export const clearCache = async () => {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/cache-clear");
    return response.data;
}